import React from "react";

import { Dialog, DialogBackdrop, DialogPanel } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/20/solid";
import booking_svg from "../assets/bookingLink.svg";
import copy_squares from "../assets/square.on.square.svg";
import { useToast } from "../provider/ToastProvider";
import { useTranslation } from "react-i18next";

export default function BookingLinkModal({
  title,
  subtitle,
  errorMsg = "Sorry for the inconvenience, The Payment Link was not Generated. Please try again.",
  open, handleClose, bookingLink }) {
  const { t, i18n } = useTranslation();
  const { addToast, addSuccessToast, addErrorToast } = useToast();

  const [copyText, setCopyText] = React.useState(t("myEvents.copy"));
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className="relative z-50"
    >
      <DialogBackdrop
        transition
        className="fixed inset-0 bg-gray-500/75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
      />
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <DialogPanel
            transition
            className="relative transform overflow-hidden rounded-xl bg-white text-black px-4 pb-4 pt-5 text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg sm:p-6 data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
          >
            <div className="absolute right-0 top-0 pr-4 pt-4 sm:block">
              <button
                type="button"
                onClick={handleClose}
                className="rounded-md [bg-white] [text-white] hover:text-gray-500 focus:outline-none focus:ring-0 focus:ring-indigo-500 focus:ring-offset-2"
              >
                <span className="sr-only">{t("inputFieldsTitle.close")}</span>
                <XMarkIcon aria-hidden="true" className="size-6" />
              </button>
            </div>
            <div className="sm:flex sm:items-center">
              {bookingLink ? (<div className={"flex flex-col gap-10 p-8 pt-4 w-full"}>
                <div className={"flex flex-row items-center justify-between border-b border-black pb-3"}>
                  <h3 className={"font-bold text-2xl line-clamp-2"}>{title !== undefined ? title : `Share Booking Link`}</h3>
                </div>
                <div className={"flex flex-col gap-2"}>
                  {/* <img src={booking_svg} alt={""} /> */}
                  <p className={"font-medium text-base [text-center]"}>
                    {subtitle !== undefined ? subtitle : `Payment Link Generated`}
                  </p>
                </div>
                <button
                  className={
                    "sm:min-w-80 h-14 bg-white text-black rounded-xl border border-gray-400 flex flex-row items-center gap-2 px-4 py-2"
                  }
                  onClick={async () => {
                    try {
                      await navigator.clipboard.writeText(bookingLink);
                      setCopyText(t("myEvents.copied"));
                      setTimeout(() => {
                        setCopyText(t("myEvents.copy"));
                      }, 3000);
                      addSuccessToast(t("myEvents.copied"));
                    } catch (e) {
                      addErrorToast(t("myEvents.failedToCopy"));
                    }
                  }}
                >
                  <span className={"grow font-semibold truncate"}>
                    {typeof bookingLink === 'string' && bookingLink.slice(0, 35)}...
                  </span>
                  <span className={"flex flex-col items-center"}>
                    {/* {copyText == "Copy" || copyText == "Kopiëren" ? (<img src={copy_squares} alt={""} />) : ( */}
                    {copyText == "Copy" || copyText == "Kopiëren" ? (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M4 16C2.9 16 2 15.1 2 14V4C2 2.9 2.9 2 4 2H14C15.1 2 16 2.9 16 4M10 8H20C21.1046 8 22 8.89543 22 10V20C22 21.1046 21.1046 22 20 22H10C8.89543 22 8 21.1046 8 20V10C8 8.89543 8.89543 8 10 8Z" stroke="#FF5733" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    ) : (
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 15L14 17L18 13M4 16C2.9 16 2 15.1 2 14V4C2 2.9 2.9 2 4 2H14C15.1 2 16 2.9 16 4M10 8H20C21.1046 8 22 8.89543 22 10V20C22 21.1046 21.1046 22 20 22H10C8.89543 22 8 21.1046 8 20V10C8 8.89543 8.89543 8 10 8Z" stroke="#FF5733" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                    )}
                    <p className={"text-[10px] font-semibold text-black"}>{copyText}</p>
                  </span>
                </button>
              </div>) : (
                <div className={"flex flex-col gap-10 p-10 w-full"}>
                  <div className={"flex flex-col gap-2"}>
                    <p className={"font-medium text-base text-center"}>
                      {errorMsg}
                    </p>
                  </div>
                </div>
              )}
            </div>
          </DialogPanel>
        </div>
      </div>

    </Dialog>
  );
}